import convertToBlack from '../ImageEditor/helpers/convertToBlack';
import dataURItoBlob from '../ImageEditor/helpers/dataURItoBlob';

const copyToCanvas = (source: HTMLCanvasElement, target: HTMLCanvasElement) => {
  if (!source) return;
  const targetCtx = target.getContext('2d');
  if (!targetCtx) return;
  targetCtx.drawImage(source, 0, 0);
};

const convertToBlackAndWhiteBlob = async (canvas: HTMLCanvasElement) => {
  const tempCanvas = document.createElement('canvas');
  document.body.appendChild(tempCanvas);
  tempCanvas.style.display = 'none';
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  copyToCanvas(canvas, tempCanvas);
  await convertToBlack(tempCanvas);
  const dataURL = tempCanvas.toDataURL();
  const blob = dataURItoBlob(dataURL);
  document.body.removeChild(tempCanvas);
  return blob;
};

export default convertToBlackAndWhiteBlob;
